import apiClient from '../authentication/utils/core/axios';

const SavedPostsAPI = {
  getMine: async () => {
    const res = await apiClient.get('/saved-posts/mine');
    if (res.status !== 200) throw new Error('Failed to fetch saved posts');
    return res.data; // { post_ids: [...], group_post_ids: [...] }
  },

  save: async ({ postId, groupPostId }) => {
    const payload = {};
    if (postId != null) payload.post_id = postId;
    if (groupPostId != null) payload.group_post_id = groupPostId;
    const res = await apiClient.post('/saved-posts/', payload);
    if (![200, 201].includes(res.status)) throw new Error('Failed to save post');
    return res.data;
  },

  unsave: async ({ postId, groupPostId }) => {
    const payload = {};
    if (postId != null) payload.post_id = postId;
    if (groupPostId != null) payload.group_post_id = groupPostId;
    const res = await apiClient.delete('/saved-posts/', { data: payload });
    if (res.status !== 200) throw new Error('Failed to unsave post');
    return res.data;
  },
};

export default SavedPostsAPI;
